import type React from "react";

/** Zweispaltige Schlüssel/Wert-Liste — Detailsektionen zeigen fast alle sowas. */
export function KeyValues({
  items,
  title,
  columns = 2,
}: {
  items: [string, React.ReactNode][];
  /** Überschrift — für mehrere Listen nebeneinander (z.B. LTE: SIM vs. Verbindung). */
  title?: string;
  columns?: 1 | 2;
}) {
  return (
    <div className="min-w-0">
      {title && (
        <h4 className="mb-2 text-xs font-semibold uppercase tracking-wide text-content-3">
          {title}
        </h4>
      )}
      <dl className={`grid grid-cols-1 gap-x-8 gap-y-2 ${columns === 2 ? "sm:grid-cols-2" : ""}`}>
        {items.map(([key, value]) => (
          <div
            key={key}
            className="flex items-baseline justify-between gap-4 border-b border-line pb-1.5"
          >
            <dt className="text-xs text-content-3">{key}</dt>
            <dd className="min-w-0 truncate text-sm text-content">{value ?? "—"}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
}
